<template>
  <div>
    <a v-if="showImage && shouldImageLink" data-test-image-with-link :href="model.link.url">
      <img :src="model.image.url" :alt="model.image.alt" />
    </a>

    <img
      v-if="showImage && !shouldImageLink"
      data-test-image-without-link
      :src="model.image.url"
      :alt="model.image.alt"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import LogoSectionElement from './interfaces/LogoSectionElement';

export default defineComponent({
  name: 'LogoFooterImage',
  props: {
    model: {
      type: Object as PropType<LogoSectionElement>,
      default() {
        return {
          link: null,
          image: null
        };
      }
    }
  },
  computed: {
    showImage(): boolean {
      return this.model !== null && this.model.image !== null;
    },
    shouldImageLink(): boolean {
      return this.model.link !== null;
    }
  }
});
</script>
